import React, { useState } from 'react';
import { ProductService } from '../../services/Product.service';
import { Product } from '../../@types/Product';
import './style/ProductAdminPage.css';

const ProductManagment: React.FC = () => {
  const [product, setProduct] = useState<Product>({
    id: 0,
    sku: '',
    name: '',
    regular_price: 0,
    stock_quantity: 0,
    quantity: 0,
    image: '',
    date_created: new Date(),
    date_modified: new Date(),
    featured: false,
    short_description: '',
    status: 'private',
    categories: [],
  });

  const [message, setMessage] = useState<string | null>(null);
  const [imageFile, setImageFile] = useState<File | null>(null);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setProduct({
      ...product,
      [name]: name === 'stock_quantity' ? Number(value) : value,
    });
  };

  const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0] || null;
    setImageFile(file);
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!product.sku || !product.name || !product.regular_price || product.stock_quantity < 0) {
      setMessage('Todos los campos son obligatorios y el stock debe ser mayor o igual a 0');
      return;
    }

    try {
      // Llamada a ProductService para agregar el producto
      await ProductService.addProduct(product);
      setMessage('Producto agregado exitosamente');
      setProduct({
        id: 0,
        sku: '',
        name: '',
        regular_price: 0,
        stock_quantity: 0,
        quantity: 0,
        image: '',
        date_created: new Date(),
        date_modified: new Date(),
        featured: false,
        short_description: '',
        status: 'private',
        categories: [],
      });
    } catch (error: any) {
      setMessage(error.message || 'Hubo un problema con la conexión al servidor');
    }
  };

  const handleImageUpload = async (e: React.FormEvent) => {
    e.preventDefault();

    // console.log(
    //   `imageFile: ${imageFile}, product.sku : ${product.sku}, product.id: ${product.id}`
    // );

    if ( !imageFile|| product.sku === '') {
      setMessage('Debe seleccionar una imagen y completar los campos SKU e ID del producto');
      return;
    }

    try {
      const formData = new FormData();
      formData.append('image', imageFile);
      formData.append('sku', product.sku);
      formData.append('id', product.id.toString());

      await ProductService.uploadProductImage(formData);
      setMessage('Imagen cargada exitosamente');
    } catch (error: any) {
      setMessage(error.message || 'Hubo un problema al cargar la imagen');
    }
  };

  return (
    <div className="admin-page">
      <h2>Administrar Productos</h2>
      <form onSubmit={handleSubmit} className="admin-form">
        <label>
          SKU:
          <input
            type="text"
            name="sku"
            value={product.sku}
            onChange={handleChange}
            required
          />
        </label>
        <label>
          Nombre:
          <input
            type="text"
            name="name"
            value={product.name}
            onChange={handleChange}
            required
          />
        </label>
        <label>
          Precio Regular:
          <input
            type="text"
            name="regular_price"
            value={product.regular_price}
            onChange={handleChange}
            required
          />
        </label>
        <label>
          Cantidad en Stock:
          <input
            type="number"
            name="stock_quantity"
            value={product.stock_quantity}
            onChange={handleChange}
            required
            min="0"
          />
        </label>
        <button type="submit">Agregar Producto</button>
      </form>

      <form onSubmit={handleImageUpload} className="admin-form">
        <label>
          Seleccionar Imagen:
          <input
            type="file"
            accept="image/*"
            onChange={handleImageChange}
          />
        </label>
        <button type="submit">Subir Imagen</button>
      </form>

      {message && <p className="message">{message}</p>}
    </div>
  );
};

export default ProductManagment;
